import { CanalVendaID, CanalVenda } from '../common/canais-venda/domain';

export class ExpedicaoSearch {
    id: number;
    origemLancamento: number;
    sequencia: number;
    tipoVenda: number;
    status: number;
    statusAmostra: number;
    dataEmissao: Date;
    setorGep: number;
    quantidadeVolumesPrevistos: number;
    quantidadeVolumesEfetivos: number;
    idPessoa: number;
    codigoIntegracaoErpPessoa: string;
    nomePessoa: string;
    nomeFantasiaPessoa: string;
    codigoIntegracaoErpRepresentante: string;
    nomeRepresentante: string;
    nomeFantasiaRepresentante: string;
    idClassificacaoFaturamentoPretendida: number;
    codigoIntegracaoErpClassificacaoFaturamentoPretendida: string;
    nomeClassificacaoFaturamentoPretendida: string;
    idClassificacaoFaturamentoRealizada: number;
    codigoIntegracaoErpClassificacaoFaturamentoRealizada: string;
    nomeClassificacaoFaturamentoRealizada: string;
    dataLiberadoExpedicao: Date;
    idUsuarioLiberadoExpedicao: number;
    nomeUsuarioLiberadoExpedicao: string;
    dataInicioExpedicao: Date;
    idUsuarioInicioExpedicao: number;
    nomeUsuarioInicioExpedicao: string;
    dataTerminoExpedicao: Date;
    idUsuarioTerminoExpedicao: number;
    nomeUsuarioTerminoExpedicao: string;
    dataFaturamento: Date;
    gepExpedicao: number;
    previsaoSeparacaoExpedicaoDias: number;

    // Local de Faturamento
    idLocalFaturamento: number;
    codigoIntegracaoErpLocalFaturamento: string;
    nomeLocalFaturamento: string;

    // Canal de Venda
    idCanalVenda: number;
    canalVenda: CanalVenda;
    numeroCanalVenda: string;

    // GEP Aguardando Produção
    dataInicioAguardandoProducao: Date;
    idUsuarioInicioAguardandoProducao: number;
    nomeUsuarioInicioAguardandoProducao: string;
    dataTerminoAguardandoProducao: Date;
    idUsuarioTerminoAguardandoProducao: number;
    nomeUsuarioTerminoAguardandoProducao: string;
    gepAguardandoProducao: number;
    gepAguardandoProducaoHoras: number;

    /** Se algum item do pedido está com a caixa de embarque fracionada */
    pedidoFracionado: boolean;

    // Segmentação
    classificacoesSlug: number[];
    classificacoesNome: string;

    // Arquivos
    quantidadeArquivos: number;
    quantidadeArquivosPendenteExpedicao: number;

    // Integração ERP
    idIntegracaoErp: number;
    nomeIntegracaoErp: string;
    logoURLPlataformaIntegracaoErp: string;
    numeroErp: string;
    integradoErp: boolean;

    // Integração E-commerce
    idIntegracaoEcommerce: number;
    nomeIntegracaoEcommerce: string;
    logoURLPlataformaIntegracaoEcommerce: string;
    numeroEcommerce: string;

    /** Atributos Auxiliares */

    // Iniciar Separação
    iniciarSeparacao: boolean;
    // Terminar separação
    terminarSeparacao: boolean;
    // Liberar Coleta
    liberarColeta: boolean;
    // Tomaneio
    printRomaneio: boolean;

    constructor(props: Partial<ExpedicaoSearch>) {
        Object.assign(this, props);

        // Canal de Venda
        if (props.canalVenda) {
            this.canalVenda = CanalVenda.getById(props.canalVenda.id);
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): ExpedicaoSearch {
        return new ExpedicaoSearch(JSON.parse(json));
    }

    /** Verifica se é o canal de venda direto */
    isCanalVendaDireto(): boolean {
        return CanalVendaID.isCanalVendaDireto(this.idCanalVenda);
    }

    /** Verifica se é o canal de venda direto */
    isCanalVendaLojaVirtual(): boolean {
        return CanalVendaID.isCanalVendaLojaVirtual(this.idCanalVenda);
    }
}
